export const
	PAUSE_SET = 'PAUSE_SET'